<template>
    <div>
        <!-- Page Header -->
        <div class="mb-10">
            <h1 class="text-white font-bold text-center text-3xl md:text-5xl">Podcasts</h1>
            <p class="block text-nomad-300 text-center mt-2">Popular Somali podcasts</p>
        </div>

        <!-- Podcasts Grid -->
        <div v-if="podcasts" class="w-full grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            <Link v-for="podcast in podcasts" :key="podcast.id" :href="'/podcast/' + podcast.id" class="w-full block">
                <div
                    class="w-full text-center p-4 rounded-lg bg-nomad-800 hover:bg-nomad-700 hover:shadow-lg transition-all duration-300">
                    <!-- Podcast Image -->
                    <img :src="podcast.image" :alt="podcast.title" class="object-cover h-48 w-full rounded-lg mb-3" />
                    <!-- Podcast Title -->
                    <h2 class="text-lg font-semibold text-white truncate">
                        {{ podcast.title }}
                    </h2>
                    <!-- Host Name -->
                    <h3 class="text-md font-light text-nomad-300 mt-2 truncate">
                        {{ podcast.host }}
                    </h3>
                    <!-- Episodes Count -->
                    <span v-if="podcast.episodes_count" class="text-sm text-nomad-400 font-light inline-block mt-2">
                        {{ podcast.episodes_count }} Episodes
                    </span>
                </div>
            </Link>
        </div>
    </div>
</template>
<script setup>
defineProps({ podcasts: Object });
</script>
<script>
import { defineAsyncComponent } from 'vue'
import { Link } from "@inertiajs/vue3";
export default {
    components: {
        Link,
        'adsense': defineAsyncComponent(() => import("@/components/Adsense.vue")),
    },
    beforeMount() {
        document.title = "Somali Podcasts"
    },
}</script>